import { gql } from '@apollo/client'

export const GET_AUTOMATION_STATUS = gql`
  query getAutomationStatus($projectId: String!) {
    getAutomationStatus(projectId: $projectId) {
      status
      automationId
      errors {
        code
        message
        step
        detailsMessage
        fatal
        module
      }
    }
  }
`

export const GET_PROJECT_AUTOMATIONS = gql`
  query getProjectAutomations($projectId: String!) {
    getProjectAutomations(projectId: $projectId) {
      automations {
        automationId
        status
        entities
        createdAt
      }
    }
  }
`
